<template>
    <div>
        <CustomSelectOne :name="name" :items="items" :empty-value="emptyValue" v-model="internalValue"
                         item-label="label" item-value="value" :label="label" v-if="!loading" :required="required"
                         :noPlaceholder="noPlaceholder"/>
    </div>
</template>

<script>
    import {getHorseBreedList} from "@/swagger/vue-api-client";
    import CustomSelectOne from "./inner/CustomSelectOne";

    export default {
        name: "CustomSelectOneHorseBreed",
        props: {
            name: {
                type: String,
            },
            label: {
                type: String,
            },
            emptyValue: {
                type: Boolean,
                default: false,
            },
            required: {
                type: Boolean,
                default: false,
            },
            modelValue: null,
            noPlaceholder: {
                type: Boolean,
                default: false,
            },
        },

        emits: ["update:modelValue"],

        computed: {
            internalValue: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    this.$emit("update:modelValue", value);
                },
            },
        },

        data() {
            return {
                items: [],
                loading: false,
            };
        },

        beforeMount() {
            this.loading = true;
            getHorseBreedList()
                .then((response) => {
                    this.items = response.data;
                    this.loading = false;
                });
        },

        components: {CustomSelectOne},
    };
</script>

<style scoped>

</style>
